import { render, staticRenderFns } from "./SKU.vue?vue&type=template&id=0eb8a68e&scoped=true&"
import script from "./SKU.vue?vue&type=script&lang=js&"
export * from "./SKU.vue?vue&type=script&lang=js&"
import style0 from "./SKU.vue?vue&type=style&index=0&id=0eb8a68e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb8a68e",
  null
  
)

export default component.exports